import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {LeftArrowOutlined, RightArrowOutlined} from "@web/assets/icons";
import StorageFile from "@web/ui/containers/StorageFile";
import {Button, Carousel, Image, Typography} from "antd";
import {WindowContext} from "@web/hooks/context";

DocumentCard.propTypes = {
  file: PropTypes.object,
  path: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  preview: PropTypes.bool,
  lazy: PropTypes.bool,
};

/**
 * @function DocumentCard
 * @param {object} props
 * @param {models.File.Data} props.file
 * @param {string} props.path
 * @param {("small" | "medium" | "large" | "xl" | "xxl" | "block")} props.size
 * @param {function} props.onClick
 * @param {boolean} props.preview
 * @param {boolean} props.lazy
 * @return {Element}
 * @constructor
 */
function DocumentCard(props) {
  const [isMobile] = useContext(WindowContext);

  const [collapse, setCollapse] =
    React.useState(!!props.lazy);

  if (!props.file) {
    return null;
  }

  if (!props.file.previews?.length) {
    if (props.file.mimeType === "application/pdf" || props.file.pdf?.storageURI) {
      const storageURI = props.file.pdf?.storageURI || props.file.storageURI;
      return <div style={{background: 'rgba(255, 255, 255, 0.9)'}}>
        <StorageFile
        storageURI={storageURI}
        key={storageURI}
      >
        <Image
          className="img-document"
          onClick={props.onClick}
          wrapperStyle={{border: "solid 3px transparent"}}
          preview={!props.onClick && props.preview}
          key={storageURI}
        />
      </StorageFile>
      </div>
    }
    return <Typography.Title
      level={4}
      type="secondary"
      onClick={props.onClick}
    >
      {props.file?.mimeType?.split("/")?.[1]?.split(".")?.pop()}
    </Typography.Title>;
  }

  return <div className="thumbnail-slider-wrapper relative">
    {!collapse &&
    <Carousel
      className="ant-carousel-nav-top"
      touchMove={false}
      key={props.file.path}
      arrows={true}
      dots={false}
      lazyLoad="ondemand"
      infinite={false}
      draggable={!!isMobile}
      waitForAnimate={true}
      accessibility={false}
      adaptiveHeight={false}
      focusOnSelect={false}
      variableWidth={false}
      prevArrow={<Button ghost size="small" className="icon-right"><LeftArrowOutlined className="green-icon"/></Button>}
      nextArrow={<Button ghost size="small" className="icon-right"><RightArrowOutlined
        className="green-icon"/></Button>}
    >
      {props.file.previews.map(({storageURI}) => {
        return <StorageFile
          storageURI={storageURI}
          key={storageURI}
        >
          <Image
            className="img-document"
            onClick={props.onClick}
            preview={!props.onClick && props.preview}
            key={storageURI}
          />
        </StorageFile>
      })}
    </Carousel>}
  </div>;
}

export default DocumentCard;
